import React from 'react';

const BlogPage: React.FC = () => (
  <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex flex-col">
    <div className="max-w-4xl mx-auto flex-1 flex flex-col justify-center items-center py-12 px-4">
      <h1 className="font-playfair text-4xl font-bold text-primary-600 mb-6">Blog</h1>
      <p className="font-poppins text-gray-600 text-lg mb-6 text-center max-w-2xl">
        Read the latest updates, tips, and stories from the Content Repurposer team.
      </p>
      {/* List blog posts or articles here */}
    </div>
  </div>
);

export default BlogPage;
